<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="d-flex flex-row flex-wrap align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">Detail Mapping QR Code</h3>
            <div class="d-flex flex-row align-items-center flex-wrap">
                <div class="mr-3">
                    <span style="font-size: 15px; font-weight: 700;">
                        Total QR: {{ numberWithCommas(config.total) }}
                    </span>
                </div>
                <div class="mr-3">
                    <MultiSelect
                        v-model="filter.year"
                        :options="options.year"
                        :allow-empty="false"
                        class="qtrust-select"
                        placeholder="Tahun"
                    ></MultiSelect>
                </div>
                <div class="mr-3">
                    <MultiSelect
                        v-model="filter.month"
                        :options="options.month.map(type => type.value)"
                        :custom-label="opt => options.month.find(x => x.value == opt).title"
                        :allow-empty="false"
                        class="qtrust-select"
                        placeholder="Bulan"
                    ></MultiSelect>
                </div>
                <div class="mr-3">
                    <MultiSelect
                        v-model="filter.kode_dealer"
                        :options="options.dealer.map(x => x.code)"
                        :custom-label="opt => options.dealer.find(x => x.code == opt).name.length > 16 ? options.dealer.find(x => x.code == opt).name.substring(0, 16) + '...' : options.dealer.find(x => x.code == opt).name"
                        class="qtrust-select"
                        placeholder="Semua Dealer"
                    >
                    </MultiSelect>
                </div>
                <button
                    type="button"
                    class="btn"
                    style="background-color: white; padding: 4.5px 20px; border-radius: 4px; display: flex; align-items: center; font-size: 14px; cursor: pointer; font-weight: 500; border: 1px solid #e8e8e8;"
                    @click="exportToCSV">
                    Download CSV 
                    <i class="fas fa-file-download ml-2"></i>
                </button>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th>QR Code</th>
                        <th>Tanggal Mapping</th>
                        <th>Tanggal Data Dikirim</th>
                        <th>Kode Dealer</th>
                        <th>Nomor Mesin</th>
                        <th>Kategori Mapping</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data" v-for="dat in data">
                        <td>{{ dat.qrcode ? dat.qrcode : '-' }}</td>
                        <td>{{ dat.active_date ? moment(dat.active_date).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                        <td>{{ dat.cloud_created_at ? moment(dat.cloud_created_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                        <td>{{ dat.loc_code ? dat.loc_code : '-' }}</td>
                        <td>{{ dat.engine_no ? dat.engine_no : '-' }}</td>
                        <td>
                            <span :style="late_category_dictionary[dat.late_category]" style="padding: 3px 10px; border-radius: 4px; font-weight: bold;">
                                {{ dat.late_category }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import * as XLSX from 'xlsx';
    
    export default {
        data () {
            return {
                moment: moment,
                late_category_dictionary: {
                    "< 5 hari": {color: "#00A86B", background: "#E8FFF2"},
                    "5-14 hari": {color: "#C6B731", background: "#FCFBE1"},
                    "14-30 hari": {color: "#C9880A", background: "#FFF2EA"},
                    "> 30 hari": {color: "#EC0000", background: "#FFE8E8"},
                },
                options : {
                    year: [...new Set(Array.from({length:5}, (_,i)=>Math.max(parseInt(moment().format('YYYY'))-i, 2024)))],
                    month: Array.from({length: 12}, (_, i) => ({title: moment().month(i).format('MMMM'), value: i + 1})),
                    city: this.$store.getters.getCity(),
                    dealer: this.$store.getters.getDealer(),
                },
                selected: {
                    category: null
                },
                filter : {
                    year: moment().format('YYYY'),
                    month: moment().format('MM'),
                    kode_dealer: null,
                    day_diff_min: null,
                    day_diff_max: null,
                },
                config : {
                    lastPage: 0,
                    total: 0,
                    page: 1,
                    limit: 5,
                },
                data : null,
            }
        },

        mounted () {
            this.fetchPaginated();
        },
        watch : {
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.fetchPaginated();
                }
            },
            'config.page' : {
                handler : 'fetchPaginated'
            },
            'selected.category' : {
                deep: true,
                handler: 'fetchPaginated'
            }
        },
        methods : {
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            categorizeDayDiff (day_diff) {
                if (day_diff < 5) return "< 5 hari";
                else if (day_diff >= 5 && day_diff <= 14) return "5-14 hari";
                else if (day_diff >= 14 && day_diff <= 30) return "14-30 hari";
                else if (day_diff > 30) return "> 30 hari";
                else return "-";
            },
            fetchPaginated () {
                let filter = JSON.parse(JSON.stringify(this.filter));

                //Check category filter
                if (this.selected.category) {
                    if (this.selected.category == "< 5 Hari") {
                        filter.day_diff_max = 4;
                    } else if (this.selected.category == "5-14 Hari") {
                        filter.day_diff_min = 5;
                        filter.day_diff_max = 13;
                    } else if (this.selected.category == "14-30 Hari") {
                        filter.day_diff_min = 14;
                        filter.day_diff_max = 30;
                    } else if (this.selected.category == "> 30 Hari") {
                        filter.day_diff_min = 31;
                    }
                }

                this.$http.get(`/api/qrs/mapping-pkb`, {params: {...filter, ...{page: this.config.page, limit: this.config.limit}}})
                .then(async res => {
                    let data = res.data.data;
                    data.forEach(x => x.late_category = this.categorizeDayDiff(x.day_diff));
                    this.data = data;

                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                })
                .catch((err)=>console.log(err));
            },

            async exportToCSV() {
                let filter = JSON.parse(JSON.stringify(this.filter));

                if (this.selected.category) {
                    if (this.selected.category == "< 5 Hari") {
                        filter.day_diff_max = 4;
                    } else if (this.selected.category == "5-14 Hari") {
                        filter.day_diff_min = 5;
                        filter.day_diff_max = 13;
                    } else if (this.selected.category == "14-30 Hari") {
                        filter.day_diff_min = 14;
                        filter.day_diff_max = 30;
                    } else if (this.selected.category == "> 30 Hari") {
                        filter.day_diff_min = 31;
                    }
                }

                this.$http.get(`/api/qrs/mapping-pkb`,{params: {...filter, ...{limit: this.config.total}}})
                .then(async res => {
                    let response = res.data.data;
                    try {
                        const customHeaders = {
                            'qrcode': 'Kode QR',
                            // 'day_diff': 'Nomor Rangka',
                            'frame_no': 'Nomor Rangka',
                            'engine_no': 'Nomor Mesin',
                            'active_date': 'Tanggal Mapping',
                            'loc_code': 'Kode Dealer',
                        };
                        
                        const modifiedData = response.map(item => {
                            const newItem = {};
                            for (const [oldKey, newKey] of Object.entries(customHeaders)) {
                                //  if (oldKey === 'rangka') {
                                //       newItem[newKey] = "-";
                                //  }else 
                                if (item.hasOwnProperty(oldKey)) {
                                    if (oldKey === 'active_date') {
                                        newItem[newKey] = moment(item[oldKey]).format('DD MMM YYYY | HH:mm');
                                    } else {
                                    newItem[newKey] = item[oldKey];
                                    }
                                        
                                }
                            }

                            for (const key in item) {
                                if (!customHeaders.hasOwnProperty(key) && key !== 'day_diff') {
                                    newItem[key] = item[key];
                                }
                            }
                            return newItem;
                        });

                        const worksheet = XLSX.utils.json_to_sheet(modifiedData);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                        const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
                        const filename = `mapping_detail_qrcode_${timestamp}.csv`;
                        XLSX.writeFile(workbook, filename, { bookType: 'csv' });

                    } catch (error) {
                        console.error('Error fetching data or exporting CSV:', error);
                    }
                })
                .catch((err)=>console.log(err));

            },
        },
    }
</script>

<style scoped>
    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
    }
</style>